import Cookies from 'js-cookie'

export const LOGIN_TOKEN_KEY = 'login-token'

function getDomain() {
  return window.location.hostname.split('.').slice(-2).join('.')
}

export function writeAuthCookie(
  token?: string | null,
  company?: string | null
) {
  const jwt = token ?? getLoginToken()
  if (!jwt) return

  const domain = getDomain()
  Cookies.set('jwt', jwt, { domain })

  const companyShortName = company ?? getCompanyShortName()
  if (!!companyShortName) Cookies.set('company', companyShortName, { domain })
}

export function getCompanyShortName() {
  const companyMatch = window.location.pathname.match(/\/c\/([\w-]+)/)
  const companyShortName = companyMatch?.pop()
  return companyShortName ?? null
}

export function setLoginToken(token: string) {
  localStorage.setItem(LOGIN_TOKEN_KEY, token)
  writeAuthCookie(token)
}

export function hasSavedLoginToken() {
  return !!localStorage.getItem(LOGIN_TOKEN_KEY)
}

export function getLoginToken() {
  return localStorage.getItem(LOGIN_TOKEN_KEY)
}

export function removeLoginToken() {
  localStorage.removeItem(LOGIN_TOKEN_KEY)
}
